import { USERROLE } from '../shared/shared/models';

// Central registry describing every top-level app module/utility.
// Drives the header nav switcher and per-module access checks.
export interface AppModuleNavItem {
  id: string;
  label: string;
  route: string;
  icon?: string;
  group: 'supervision' | 'utility';
  // When set, the user's role must be one of these.
  allowedRoles?: USERROLE[];
  // When set, the user's id must appear in Constant.config[configUsersKey] (uppercased list).
  configUsersKey?: string;
}

export const APP_MODULES: AppModuleNavItem[] = [
  {
    id: 'supervision',
    label: 'Supervision',
    route: '/home',
    icon: 'assessment',
    group: 'supervision'
  },
  {
    id: 'supervision-admin',
    label: 'Admin',
    route: '/admin',
    icon: 'settings',
    group: 'supervision',
    allowedRoles: [USERROLE.SUPERVISION]
  },
  {
    id: 'cheque-submission',
    label: 'Cheque Submission',
    route: '/cheque-submission',
    icon: 'request_quote',
    group: 'utility',
    configUsersKey: 'chequeUsers',
    allowedRoles: [USERROLE.SUPERVISION]
  }
];
